// Termin-Anzeige der Auftragskarte (Port der v6-Helfer schedLabel/minToTime). Reine lokale Datums-/Zeit-
// Formatierung — kein toISOString (Mitternachts-Bug), die Aufrufer reichen „heute"/„morgen" als lokale
// YMD-Strings herein.

const WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']

/** Minuten ab Mitternacht → „HH:MM" (auch Wert-Format von <input type=time>; genutzt u. a. von der Plantafel). */
export function minToTime(min: number): string {
  return `${String(Math.floor(min / 60)).padStart(2, '0')}:${String(min % 60).padStart(2, '0')}`
}

/** „heute" / „morgen" / „Di 10.6." — Tag-Kontext für die Karte. */
export function schedLabel(dateStr: string, today: string, tomorrow: string): string {
  if (dateStr === today) return 'heute'
  if (dateStr === tomorrow) return 'morgen'
  const d = new Date(`${dateStr}T00:00:00`)
  return `${WEEKDAYS[d.getDay()]} ${d.getDate()}.${d.getMonth() + 1}.`
}

/**
 * Termin-Fakt der Karte: Tag-Label + optionale Uhrzeit-Spanne, z. B. „heute 08:00–10:00" oder „Di 10.6.".
 * Leerer String, wenn weder Datum noch Startzeit gesetzt sind (dann zeigt die Karte den Fakt gar nicht).
 */
export function scheduleFact(
  scheduledDate: string | null,
  startMin: number | null,
  endMin: number | null,
  today: string,
  tomorrow: string,
): string {
  const label = scheduledDate ? schedLabel(scheduledDate, today, tomorrow) : ''
  const time = startMin != null ? minToTime(startMin) + (endMin != null ? `–${minToTime(endMin)}` : '') : ''
  return [label, time].filter(Boolean).join(' ')
}
